import { announceCartFeedback, getCartErrorMessage } from '@theme/cart-feedback';

/**
 * One-click add to cart for product cards with a single variant.
 * Reads the variant (and optional pre-order selling plan) from data attributes,
 * adds one unit through Standard Actions, then opens the cart drawer.
 */
class SCardAdd extends HTMLElement {
  #ac;
  #busy = false;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-card-add]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      this.#add(button);
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  async #add(button) {
    if (this.#busy || button.getAttribute('aria-disabled') === 'true') return;

    const variantId = this.dataset.variantId;
    if (!variantId || !window.Shopify?.actions?.updateCart) return;

    const line = { merchandiseId: variantId, quantity: 1 };
    if (this.dataset.sellingPlanId) line.sellingPlanId = this.dataset.sellingPlanId;

    this.#busy = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('opacity-50', 'cursor-wait');

    try {
      const result = await window.Shopify.actions.updateCart(
        { lines: [line] },
        { event: { context: 'collection', detail: { source: 's-card-add', productId: this.dataset.productId } } }
      );
      const errorMessage = result?.userErrors?.[0]?.message;
      if (errorMessage) {
        announceCartFeedback(errorMessage, { toast: true });
      } else {
        await window.Shopify.actions.openCart?.();
      }
    } catch (error) {
      announceCartFeedback(getCartErrorMessage(error) || this.dataset.errorMessage || '', { toast: true });
    } finally {
      this.#busy = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('opacity-50', 'cursor-wait');
    }
  }
}

if (!customElements.get('s-card-add')) {
  customElements.define('s-card-add', SCardAdd);
}
